export default "__VITE_ASSET__CUuNyLmd__"